
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../loader-overlay/loader-overlay.component';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import { ItemFormErrorWithTranslatorComponent } from '../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import UserRestServices from '../../services/user-rest.service';
import { MatSelectModule } from '@angular/material/select';
import {RouterLink} from "@angular/router";
import AngularFilterHelperService from '../../services/angular-filter-helper.service';

@Component({
    standalone: true,
    selector: 'modal-totp-authentication',
    templateUrl: './modal-totp-authentication.component.html',
    imports: [
        CommonModule, MatSelectModule, TranslatePipe, RouterLink, ItemFormErrorWithTranslatorComponent, FormsModule, LoaderOverlayComponent
    ]
})
export class ModalTotpAuthenticationComponent implements OnInit {
    private restService: RestService = inject(RestService);
    private userRestServices: UserRestServices = inject(UserRestServices);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private dialogRef = inject(MatDialogRef<ModalTotpAuthenticationComponent>);
    private data = inject(MAT_DIALOG_DATA);
    private session: Session = inject(Session);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

        this.vm.submit = this.submit;
        this.vm.close = this.close;
        this.vm.handleInstructionView = this.handleInstructionView;
        this.vm.onAppSelectionChange = this.onAppSelectionChange;
        this.vm.isVerificationSuccess = false;
        this.vm.showInstruction= true;

        this.vm.initialized = true;

        this.vm.user = this.session.getSession().user || {};

        var lang: any = this.vm.user.deviceLanguage || 'en_GB';
        if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
            this.vm.appLogoLang = lang.split("_")[0];
        } else {
            this.vm.appLogoLang = 'en';
        }

        this.vm.googleAndroidLink = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pli=1';
        this.vm.msAndroidLink = 'https://play.google.com/store/apps/details?id=com.azure.authenticator&pli=1';
        this.vm.googleIosLink = 'https://apps.apple.com/app/google-authenticator/id388497605?platform=iphone';
        this.vm.msIosLink = 'https://apps.apple.com/app/microsoft-authenticator/id983156458?platform=iphone';
        var googleAuthenticatorApp = this.angularFilterHelperService.translate('Modal.Profile.Authentication.Google_Authenticator_Subtitle');
        var msAuthenticatorApp = this.angularFilterHelperService.translate('Modal.Profile.Authentication.MS_Authenticator_Subtitle');
        var applePasswordManager = this.angularFilterHelperService.translate('Modal.Profile.Authentication.Apple_Password_Manager_Subtitle');
        this.vm.apps = [
            { value: 'google', label: googleAuthenticatorApp },
            { value: 'ms', label: msAuthenticatorApp },
            { value: 'apple', label: applePasswordManager }
        ];
    }

    onAppSelectionChange(value: string): void {
        this.vm.totpApp = value;

        this.vm.isGoogleAuthenticator = value === 'google';
        this.vm.isMsAuthenticator = value === 'ms';
        this.vm.isApplePasswordManager = value === 'apple';
    }

    submit() {
        this.vm.submitted = true;
        this.vm.processing = true;
        this.userRestServices.enableTotpAuthentication(
            {
                userId: this.vm.user.id,
                enableTotpAuth: true,
                verificationCode: this.vm.verificationCode
            },
            (res) => {
                this.vm.processing = false;
                this.vm.isVerificationSuccess = true;
                this.dialogRef.close('SUCCESS');
            },
            (err) => {
                this.vm.processing = false;
                console.log(err);
                if (err.status === 403 && err.error === "INVALID_TOTP_AUTHENTICATION_CODE") {
                    this.vm.showWrongVerificationError = true;
                }
            }
        );
    }

    close() {
        this.dialogRef.close(undefined);
    }

    handleInstructionView() {
        this.vm.showInstruction = !this.vm.showInstruction;
    }

}